<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path
      stroke="null"
      d="M19.937 5.984L10 15.921.063 5.984 1.97 4.08l8.03 8.03 8.03-8.03 1.907 1.905z"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
